<template>
  <ul class="breadcrumbs">
    <li>
      <a 
        href="" 
        @click.prevent="goBack"
      >
        <font-awesome-icon
          :style="{ marginRight: '8px' }"
          icon="chevron-left"
        />terug</a>
    </li>
  </ul>
</template>
<script>
export default {
  name: "Breadcrumb",
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
